module.exports = __webpack_public_path__ + "img/battery-groupe-no-number-center.5d922826.svg";